import React from 'react';
import { Typography } from '../../../../../components';
import dayjs from 'dayjs';
import './MoveGroupsAndAppsTable.scss';

const { Title, Text } = Typography;

export const TableHeader = ({ selectedName, moveGroupData }) => {
    return (
        <div className="inventory-table-header">
            <Title level={2} className="table-title">
                {selectedName}
                {moveGroupData?.target_migration_date && (
                    <Text type="secondary" className="target-migration-date">
                        Target Date: {dayjs(moveGroupData.target_migration_date).format('MMM DD, YYYY')}
                    </Text>
                )}
            </Title>
        </div>
    );
};
